<template>
  <sdPageHeader :title="$t('pages.notifications.title')"
    ><template v-slot:buttons>
      <div class="page-header-actions">
        <sdButton size="small" type="primary" @click="allRead">
          <sdFeatherIcons type="check" size="14" />
          {{ $t('pages.notifications.all-read') }}
        </sdButton>
      </div>
    </template>
  </sdPageHeader>
  <Main>
    <sdCards>
      <div v-if="isLoading" class="spin">
        <a-spin />
      </div>
      <div v-else>
        <ActivityContents>
          <ul class="activity-list">
            <li
              class="activity-list__single"
              v-for="(notify, index) in notifications"
              :key="index"
              @click="read(index)"
            >
              <span class="activity-icon primary">
                <sdFeatherIcons type="package" size="14" />
              </span>
              <div class="activity-content">
                <div class="activity-info">
                  <p>
                    {{ $store.state.i18n.i_lang == 'en' ? notify.message_en : notify.message }}
                    <a-badge dot v-if="!notify.is_read" />
                    <span class="hour">{{ dateTr(notify.created_at) }}</span>
                  </p>
                </div>
                <a class="activity-more" to="#">
                  <sdDropdown :action="['click']">
                    <template #overlay>
                      <a to="#">
                        <span>Delete</span>
                      </a>
                    </template>
                    <sdFeatherIcons type="more-horizontal" />
                  </sdDropdown>
                </a>
              </div>
            </li>
          </ul>
        </ActivityContents>
      </div>
    </sdCards>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';
import { ActivityContents } from './style';
import { dateToTr } from '@/utility/helper.js';

export default {
  name: 'AppList',
  components: {
    Main,
    ActivityContents,
  },
  data() {
    return {
      limit: 30,
      notifications: [],
    };
  },
  methods: {
    getNotifications() {
      var _this = this;
      this.$appAxios.post(this.$endpoints.notifications_get, { limit: this.limit }).then((resp) => {
        if (resp.data.status === true) {
          _this.notifications = resp.data.data.data;
          _this.unreadCount = resp.data.data.unread_count;
        }
      });
    },
    read(index) {
      console.log(index);
      let notify = this.notifications[index];
      if (notify.is_read == 0) {
        let id = notify.id;
        notify.is_read = 1;
        this.$appAxios.post(this.$endpoints.notifications_read, { id: id }).then((resp) => {});
      }
    },
    allRead() {
      var _this = this;
      this.$appAxios.post(this.$endpoints.notifications_allread).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
          _this.notifications.forEach(function (item, index) {
            _this.notifications[index].is_read = 1;
          });
        }
      });
    },
    dateTr(date) {
      return dateToTr(date);
    },
  },
  mounted() {
    this.getNotifications();
  },
};
</script>